module.exports = __webpack_public_path__ + "static/media/codap.c02541ff.ico";